import React, { Component } from 'react';
import { Row, Col, Button, Table, Spinner, Alert, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router';
import _ from 'underscore';
import { Global } from '~/App'
import API from '~/API';
import moment from 'moment';

class Cartas extends Component {
    constructor() {
        super();
        this.state = {
            datos: [],
            cargando: true,
            error: null
        }
        this.ConsultaCartas = this.ConsultaCartas.bind(this)
        this.descargarDocumento = this.descargarDocumento.bind(this)
        this.getCartaPdf = this.getCartaPdf.bind(this)
        this.getDocumentoCobro = this.getDocumentoCobro.bind(this)
    }

    // --- NUEVO: Controlador principal para el botón "Descargar" ---
    // Decide qué método de descarga llamar basado en el TipoDocumento
    async descargarDocumento(item) {
        if (item.TipoDocumento === 'CARTA') {
            // Es una carta formal, llama al método para descargar cartas
            this.getCartaPdf(item);
        } else if (item.TipoDocumento === 'DOCUMENTO_COBRO') {
            // Es una notificación en la boleta, llama al método para descargar documentos de cobro
            this.getDocumentoCobro(item.IdProceso, item.NoDoc);
        }
    }

    // --- Lógica original de Cartas.jsx para descargar la CARTA PDF ---
    async getCartaPdf(carta) {
        var win = window.open('about:blank', '_blank');
        if (win) {
            win.document.write(`<html><head><title>Cargando carta...</title></head><body style="display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; font-family: Arial, sans-serif;"><div style="text-align: center;"><div style="border: 8px solid #f3f3f3; border-top: 8px solid #3498db; border-radius: 50%; width: 60px; height: 60px; animation: spin 1s linear infinite;"></div><div style="margin-top: 20px; font-size: 18px; color: #555;">Cargando carta...</div></div><style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style></body></html>`);
            win.document.close();
        }

        try {
            const { empresa, idServicio } = this.props.Servicio;
            const datosBase64 = await API.Call(`Consulta/${empresa}/Cartas/Descargar/${idServicio}/${carta.IdProceso}/${carta.IdentificadorCarta}`);
            
            if (win && !win.closed) {
                var byteCharacters = atob(datosBase64);
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: "application/pdf" });

                win.document.body.style.margin = '0';
                win.document.body.innerHTML = '';
                var embed = document.createElement('embed');
                embed.setAttribute('src', URL.createObjectURL(file));
                embed.setAttribute('type', 'application/pdf');
                embed.style.width = '100%';
                embed.style.height = '100%';
                
                win.document.title = 'Carta';
                win.document.body.appendChild(embed);
            }
        } catch (error) {
            if (win) win.close();
        }
    }

    // --- NUEVO: Lógica traída desde Documentos.jsx para descargar el DOCUMENTO DE COBRO ---
    async getDocumentoCobro(idProceso, noDoc) {
        var win = window.open('about:blank', '_blank');
        if (win) {
            win.document.write(`<html><head><title>Cargando documento...</title></head><body style="display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; font-family: Arial, sans-serif;"><div style="text-align: center;"><div style="border: 8px solid #f3f3f3; border-top: 8px solid #3498db; border-radius: 50%; width: 60px; height: 60px; animation: spin 1s linear infinite;"></div><div style="margin-top: 20px; font-size: 18px; color: #555;">Cargando documento...</div></div><style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style></body></html>`);
            win.document.close();
        }
    
        try {
            var datos = await API.Call(`Consulta/${this.props.Servicio.empresa}/Documento/${this.props.Servicio.idServicio}/${idProceso}/${noDoc}`);
        } catch {
            if (win) win.close();
            return;
        }
    
        if (win && !win.closed) {
            var byteCharacters = atob(datos);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            let file = new Blob([byteArray], { type: "application/pdf;base64" });
    
            win.document.body.innerHTML = ''; 
            var blobHtmlElement = document.createElement('object');
            blobHtmlElement.style.position = 'fixed';
            blobHtmlElement.style.top = '0';
            blobHtmlElement.style.left = '0';
            blobHtmlElement.style.bottom = '0';
            blobHtmlElement.style.right = '0';
            blobHtmlElement.style.width = '100%';
            blobHtmlElement.style.height = '100%';
            blobHtmlElement.setAttribute('type', 'application/pdf');
            blobHtmlElement.setAttribute('data', URL.createObjectURL(file));
    
            win.document.title = 'Documento Tributario Electrónico';
            win.document.body.appendChild(blobHtmlElement);
        }
    }

    componentWillMount() {
        this.Redirect(this.props);
        this.ConsultaCartas(this.props);
    }

    componentWillReceiveProps(props) {
        this.Redirect(props)
        if (this.props.Servicio.empresa !== props.Servicio.empresa || this.props.Servicio.idServicio !== props.Servicio.idServicio) {
            this.ConsultaCartas(props);
        }
    }

    Redirect(props) {
        if (!props.Servicio.idServicio) {
            props.history.replace("/sucursal")
        }
    }

    async ConsultaCartas(props) {
        if (!props.Servicio.idServicio || !props.Servicio.empresa) {
            return;
        }
        this.setState({ cargando: true, error: null });
        try {
            // Esta llamada ahora devuelve tanto cartas como documentos de cobro con notificaciones
            const datos = await API.Call(`Consulta/${props.Servicio.empresa}/Cartas/${props.Servicio.idServicio}`);
            this.setState({ datos, cargando: false });
        } catch (e) {
            this.setState({ cargando: false, error: "No se pudieron cargar las cartas y notificaciones." });
        }
    }

    render() {
        if (this.state.cargando) {
            return <div className="text-center p-4"><Spinner /></div>;
        }

        if (this.state.error) {
            return <Alert color="danger">{this.state.error}</Alert>;
        }

        return (
            <div>
                {this.state.datos.length > 0 ? (
                    <>
                        {/* Vista para escritorio y tablet */}
                        <div className="d-none d-md-block">
                            <Table responsive hover className="mt-3">
                                <thead>
                                    <tr>
                                        <th>Tipo de Documento</th>
                                        <th>Fecha de Emisión</th>
                                        <th className="text-center">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.datos.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <strong>{item.TipoCarta}</strong>
                                                {/* Agregamos una etiqueta visual para saber el tipo */}
                                                {item.IdentificadorCarta === 'notificacioncorte' && (
                                                    <span className={`badge ml-2 ${item.TipoDocumento === 'CARTA' ? 'badge-warning' : 'badge-info'}`}>
                                                        {item.TipoDocumento === 'CARTA' ? 'Carta Formal' : 'Aviso en Boleta'}
                                                    </span>
                                                )}
                                            </td>
                                            <td>{moment(item.FechaEmision).format('DD/MM/YYYY')}</td>
                                            <td className="text-center">
                                                <Button onClick={() => this.descargarDocumento(item)} color="primary" size="sm">
                                                    <i className="fa fa-download mr-1" /> Descargar
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>

                        {/* Vista para móviles */}
                        <div className="d-md-none">
                            {this.state.datos.map((item, index) => (
                                <Card key={index} className="mb-3">
                                    <CardBody>
                                        <p><i className="fa fa-file-text-o mr-2" /><strong>Tipo de Documento:</strong> {item.TipoCarta}</p>
                                        {item.IdentificadorCarta === 'notificacioncorte' && (
                                            <p><i className="fa fa-tag mr-2" /><strong>Tipo:</strong> <span className={`badge ${item.TipoDocumento === 'CARTA' ? 'badge-warning' : 'badge-info'}`}>
                                                {item.TipoDocumento === 'CARTA' ? 'Carta Formal' : 'Aviso en Boleta'}
                                            </span></p>
                                        )}
                                        <p><i className="fa fa-calendar mr-2" /><strong>Fecha de Emisión:</strong> {moment(item.FechaEmision).format('DD/MM/YYYY')}</p>
                                        <Button onClick={() => this.descargarDocumento(item)} color="primary" size="sm" className="w-100 mt-2">
                                            <i className="fa fa-download mr-1" /> Descargar
                                        </Button>
                                    </CardBody>
                                </Card>
                            ))}
                        </div>
                    </>
                ) : (
                    <p className="text-center text-muted mt-4">No se encontraron cartas emitidas en los últimos dos años para este servicio.</p>
                )}
            </div>
        )
    }
}

export default withRouter(Cartas);